// Copyright (c) Docugami, Inc. All rights reserved.

import { useMemo } from "react";
import { DgmlInstancesSingleton, useDocumentDgml, useTextVersion } from "./documentDgml";
import { useAppSelector } from "./redux";
import { selectDgmlNodesByFolderId } from "store/dgml/dgmlSelectors";

export function useRichText(spanId?: string): string {
    const { documentId, isInitialized } = useDocumentDgml();
    const textVersion = useTextVersion(documentId)

    const addedChunkValue = useAppSelector(state => selectDgmlNodesByFolderId(state, documentId)?.chunks?.entities[spanId ?? '']?.addedChunkValue);

    const isReady = isInitialized();
    return useMemo(() => !!spanId && !!isReady ? DgmlInstancesSingleton.getHtmlStringBySpanId(spanId, documentId) : '',
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [textVersion, spanId, documentId, isReady, addedChunkValue]) ?? '';
}
